import { useContext } from "react";
import { ProjectDetailPageContext, PageNewState } from ".";

export const usePageState = () => {
  const { pageState, setPageState } = useContext(ProjectDetailPageContext);
  return [
    pageState,
    (newState: PageNewState) => setPageState(newState),
  ] as const;
};
